// extracted by mini-css-extract-plugin
export default {"label":"styles_label__y6j9j","icon":"styles_icon__y2G6g"};